import { render, staticRenderFns } from "./Organisms.vue?vue&type=template&id=a2225e44&"
import script from "./Organisms.vue?vue&type=script&lang=js&"
export * from "./Organisms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports